<p-editor
  #editor
  [(ngModel)]="body"
  [style]="{ height: '4rem' }"
  [modules]="modules"
  (ngModelChange)="sentToParent()"
  [placeholder]="'Add a comment...'"
>
</p-editor>
